<script setup>
import Textarea from 'primevue/textarea'
import Skeleton from './Skeleton.vue'

import { ref, toRefs } from 'vue'
import { useRoute } from 'vue-router'
import { useRouter } from 'vue-router'
import { usePrimeVue } from 'primevue/config'

import { dayNames, dayNamesMin, dayNamesShort, monthNamesShort, mounthNames } from '@/utils/config-locale'
import { formatDate } from '@/utils/date-fns'
import { useAlert } from '@/composables/useAlert'

import { useAtividadeConsolidada } from '@/stores/services/atividadeConsolidada'
import { useAtividadesTipos } from '@/stores/services/atividadesTipos'
import { usePatios } from '@/stores/services/patios'
import { useOrdemDeServico } from '@/stores/services/ordemDeServico'

const { push } = useRouter()
const { params } = useRoute()
const { alertSucess, alertWarn } = useAlert()

const { obterAtividadePorId, registrarAtividade, editarAtividade, obterDetalhesAtividades } = useAtividadeConsolidada()
const { atividadePorId } = toRefs(useAtividadeConsolidada())

const { obterAtividadeTipo } = useAtividadesTipos()
const { loadingAtividadeTipo, atividadesTipos } = toRefs(useAtividadesTipos())

const { obterPatios } = usePatios()
const { loadingPatios, patios } = toRefs(usePatios())

const { obterOrdemDeServico } = useOrdemDeServico()
const { ordemDeServico: ordemDeServicos, loadingObter } = toRefs(useOrdemDeServico())

const primeVue = usePrimeVue()
const title = ref('Incluir Registro')
const active = ref(false)
const atvDialog = ref(false)
const trocarOsDialog = ref(false)
const dataAtividade = ref(null)
const data_ordem = ref(null)
const horaAtividade = ref(null)
const atividade_tipo = ref(null)
const osSelecionadaId = ref(null)
const locomotiva = ref('AAA9999')
const mascara = ref('*******')
const locomotivaFake = ref('')
const ordemDeServico = ref(null)
const ordemDeServicoAnterior = ref(null)
const patioOrigem = ref(null)
const patioDestino = ref(null)
const observacao = ref(null)
const adicionalZas = ref(null)
const adicionalSerraCremalheira = ref(null)
const adicionalMonoconducao = ref(null)
const adicionalMonitoria = ref(null)
const matriculaMonitoria = ref(null)
const patioFormato = ref(null)
const form = ref({
  pagina: null,
  limite: null,
  escalaId: params.id
})
const confirmacoesLocal = ref([])
const codigoMensagem = ref(null)
const solicitarConfirmacaoLocal = ref(null)
const mensagemConfirmacao = ref(null)
const atividadeTipoAtivos = ref(null)
const ordensDeServico = ref(null)
const abrirAlerta = ref(false)
const payload = ref(null)
const habilitarOs = ref(false)
const permiteEditarHorario = ref(true)
const desabilitarConfirm = ref(false)
const exibirPrefixo = ref(false)
const exibirDestino = ref(false)
const configuracao = ref(false)
const loading = ref(false)

const props = defineProps({
  matricula: null,
  escalaId: null,
  data_fixa: false,
  data_escala: null,
  label: null,
  icon: null,
  id: null,
  dataTest: null
})

const emit = defineEmits(['eventoAtividade'])

const abrirDialogAlerta = () => {
  active.value = true
  abrirAlerta.value = true
  active.value = false
}

const onKeypressData = async (event) => {
  if (dataAtividade.value.indexOf('_') == -1) {
    const filtro = { dataAtividade: dataAtividade.value }
    await carregarPatios(filtro)
    await buscarOrdemDeServicoSugerida()
  }
}

const onChangeData = async (event) => {
  if (dataAtividade.value.length == 0) {
    const escala = props.data_escala.split(' ')
    dataAtividade.value = escala[0]
  }

  await buscarOrdemDeServicoSugerida()
}
const onChangeHora = async (event) => await buscarOrdemDeServicoSugerida()

const buscarOrdemDeServicoSugerida = async (filtroParam) => {
  if (dataAtividade.value != '' && horaAtividade.value != '') {
    habilitarOs.value = true
    let filtro = {}

    if (filtroParam) filtro = filtroParam

    filtro.funcionario = props.matricula
    filtro.somenteDisponiveis = true
    filtro.dataReferencia = `${dataAtividade.value} ${horaAtividade.value}`
    filtro.tipoBusca = 2

    carregarOrdemDeServicos(filtro)
  }
}

const carregarPatios = async (filtro) => {
  await obterPatios(filtro)

  patioFormato.value = patios.value.items.map((p) => {
    return {
      id: p.id,
      sigla: p.sigla,
      descricao: p.descricao,
      descricaoCompleto: p.descricaoCompleto
    }
  })
}

const carregarOrdemDeServicos = async (filtro) => {
  if (habilitarOs.value) {
    await obterOrdemDeServico(filtro)
    if (ordemDeServicos.value != null && ordemDeServicos.value.items != null) {
      ordensDeServico.value = ordemDeServicos.value.items.map((o) => {
        return {
          id: o.id,
          dataInicio: o.dataInicio,
          sugerida: o.sugerida
        }
      })

      const osSugerida = ordensDeServico.value.find((o) => o.sugerida)

      if (osSugerida) {
        ordemDeServico.value = osSugerida
        ordemDeServicoAnterior.value = ordemDeServico.value
        const osSugeridaObj = ordemDeServicos.value.items.find((o) => o.id == osSugerida.id)

        preencherAtividadeConformeOs(osSugeridaObj)
      }
    }
  }
}

const onChangeAtividadeTipo = async (event) => await exibirCampos(event.value, true)

const onChangeOrdemDeServico = (event) => {
  if (event.value != null) {
    trocarOsDialog.value = true
    osSelecionadaId.value = event.value.id
  }
}

const cancelarPreenchhimentoOs = () => (trocarOsDialog.value = false)

const preencherAtividadeConformeOs = (osSugerida) => {
  let osSelecionada

  if (osSugerida) osSelecionada = osSugerida
  else osSelecionada = ordemDeServicos.value.items.find((o) => o.id == osSelecionadaId.value)

  patioOrigem.value = obterPatioPorId(osSelecionada.patioOrigem.id)
  patioDestino.value = obterPatioPorId(osSelecionada.patioDestino?.id)
  atividade_tipo.value = obterAtividadeTipoPorId(osSelecionada.atividade?.id)
  locomotiva.value = obterPrefixo(osSelecionada)

  trocarOsDialog.value = false
  ordemDeServico.value = ordensDeServico.value.find((o) => o.id == osSelecionada.id)
}

const obterPatioPorId = (id) => {
  if (id != undefined) {
    let patioSelecionado = patios.value.items
      .filter((p) => p.id == id)
      .map((p) => {
        return {
          id: p.id,
          sigla: p.sigla,
          descricao: p.descricao,
          descricaoCompleto: p.descricaoCompleto
        }
      })

    return patioSelecionado[0]
  }
}

const obterAtividadeTipoPorId = (id) => {
  if (id != undefined) {
    let atividadeTipoSelecionada = atividadesTipos.value.items
      .filter((a) => a.id == id)
      .map((a) => {
        return {
          id: a.id,
          descricao: a.descricao,
          sigla: a.sigla,
          descricaoCompleto: a.descricaoCompleto,
          prefixo: a.prefixo,
          deslocamento: a.deslocamento
        }
      })

    exibirPrefixo.value = atividadeTipoSelecionada[0].prefixo.obrigatorio

    if (exibirPrefixo.value) mascara.value = 'aaa9999'
    else mascara.value = ''

    return atividadeTipoSelecionada[0]
  }
}

const obterPrefixo = (osSelecionada) => {
  if (osSelecionada.prefixoTremReal != null || osSelecionada.prefixoTremReal != '') return osSelecionada.prefixoTremReal.toUpperCase()
  if (osSelecionada.prefixoTrem != null || osSelecionada.prefixoTrem != '') return osSelecionada.prefixoTrem.toUpperCase()
  return ''
}

const abrirDialog = async () => {
  loading.value = true
  atvDialog.value = true
  await obterAtividadeTipo()

  if (!props.id) {
    const escala = props.data_escala.split(' ')
    configuracao.value = JSON.parse(localStorage.getItem('configuracoes'))
    dataAtividade.value = escala[0]
    var filtro = { funcionario: props.matricula, somenteDisponiveis: true, dataAtividade: dataAtividade.value }
    await carregarPatios(filtro)
    await carregarOrdemDeServicos(filtro)
  }

  atividadeTipoAtivos.value = atividadesTipos.value.items
    .filter((a) => a.ativo == true)
    .map((a) => {
      return {
        id: a.id,
        descricao: a.descricao,
        sigla: a.sigla,
        descricaoCompleto: a.descricaoCompleto,
        prefixo: a.prefixo,
        deslocamento: a.deslocamento
      }
    })

  primeVue.config.locale.monthNames = mounthNames
  primeVue.config.locale.dayNames = dayNames
  primeVue.config.locale.dayNamesShort = dayNamesShort
  primeVue.config.locale.dayNamesMin = dayNamesMin
  primeVue.config.locale.monthNamesShort = monthNamesShort

  const escala = props.data_escala.split(' ')

  dataAtividade.value = escala[0]

  if (props.id) {
    title.value = 'Alterar Registro'
    await obterAtividadePorId(props.id)

    configuracao.value = JSON.parse(localStorage.getItem('configuracoes'))
    var filtro = { dataAtividade: atividadePorId.value.dataAtividade }
    await carregarPatios(filtro)

    if (atividadePorId.value) {
      horaAtividade.value = atividadePorId.value.hora
      locomotiva.value = atividadePorId.value.locomotiva
      dataAtividade.value = atividadePorId.value.dataAtividade
      atividade_tipo.value = atividadePorId.value.atividadeTipo
      patioOrigem.value = atividadePorId.value.patioOrigem
      patioDestino.value = atividadePorId.value.patioDestino
      ordemDeServico.value = atividadePorId.value.ordemDeServico
      ordemDeServicoAnterior.value = ordemDeServico.value
      observacao.value = atividadePorId.value.observacao
      adicionalZas.value = atividadePorId.value.adicionalZas
      adicionalSerraCremalheira.value = atividadePorId.value.adicionalSerraCremalheira
      adicionalMonoconducao.value = atividadePorId.value.adicionalMonoconducao
      permiteEditarHorario.value = atividadePorId.value.permiteEditarHorario
      adicionalMonitoria.value = atividadePorId.value.adicionalMonitoria
      matriculaMonitoria.value = atividadePorId.value.matriculaMonitoria

      filtro.somenteDisponiveis = true
      filtro.edicaoAtividade = true

      if (ordemDeServico.value != null && ordemDeServico.value.id != null) {
        filtro.idOrdemDeServico = ordemDeServico.value.id
      }

      await buscarOrdemDeServicoSugerida(filtro)
      await exibirCampos(atividade_tipo.value, false)
    }
  }
  if (!props.id) {
    horaAtividade.value = null
    permiteEditarHorario.value = true
  }
  loading.value = false
}

const exibirCampos = async (atividadeTipoParam, limparCampos) => {
  const atividadeTipo = atividadesTipos.value.items
    .filter((a) => a.id == atividadeTipoParam.id)
    .map((a) => {
      return {
        prefixo: a.prefixo,
        deslocamento: a.deslocamento
      }
    })

  if (atividadeTipo != undefined && atividadeTipo.length > 0) {
    exibirPrefixo.value = atividadeTipo[0].prefixo.obrigatorio
    exibirDestino.value = atividadeTipo[0].deslocamento.obrigatorio

    if (exibirPrefixo.value) mascara.value = 'aaa9999'
    else mascara.value = ''

    if (limparCampos) {
      locomotiva.value = null
      patioDestino.value = null
    }
  }
}

const cancelar = () => {
  active.value = true
  atvDialog.value = false
  horaAtividade.value = null
  dataAtividade.value = null
  atividade_tipo.value = null
  locomotiva.value = null
  patioOrigem.value = null
  patioDestino.value = null
  ordemDeServico.value = null
  observacao.value = null
  adicionalZas.value = null
  adicionalSerraCremalheira.value = null
  adicionalMonoconducao.value = null
  adicionalMonitoria.value = null
  permiteEditarHorario.value = null
  active.value = false
}

const confirmaAtividade = async () => {
  desabilitarConfirm.value = true
  active.value = true
  confirmacoesLocal.value.push(codigoMensagem.value)

  await salvarAtividade(confirmacoesLocal.value)
  active.value = false
  desabilitarConfirm.value = false
}

const validarCampos = () => {
  if (props.data_fixa) {
    if (!dataAtividade.value) alertWarn('Campo Data obrigatório!')
    else if (!horaAtividade.value) alertWarn('Hora obrigatório!')
  }
  if (!atividade_tipo.value) alertWarn('Campo Tipo da Atividade obrigatório!')
  else if (!patioOrigem.value) alertWarn('Campo Pátio Origem obrigatório!')
  else if (locomotiva.value != null && locomotiva.value.trim() != '' && locomotiva.value.length < 7)
    alertWarn('Informar o Prefixo respeitando a máscara: AAA9999')
  else if (adicionalMonitoria.value) {
    if (!matriculaMonitoria.value) {
      alertWarn('Informar a matrícula do seu par na equipagem')
    } else if (matriculaMonitoria.value.length < 8) {
      alertWarn('Matrícula do seu par na equipagem deve ter 8 digitos')
    } else return true
  } else return true
}
const salvarAtividade = async (confirmacoes) => {
  if (validarCampos() === true) {
    const data_fixa = dataAtividade.value ? props.data_escala.split(' ') : null

    data_ordem.value = dataAtividade.value.split('/')

    const dataAtividadeArray = dataAtividade.value ? dataAtividade.value.split('/') : null

    payload.value = {
      dataAtividade: dataAtividadeArray
        ? `${dataAtividadeArray[2]}-${dataAtividadeArray[1]}-${dataAtividadeArray[0]} ${horaAtividade.value}`
        : `${formatDate(new Date(data_ordem.value[2], data_ordem.value[1] - 1, data_ordem.value[0]))} ${horaAtividade.value}`,
      matricula: props.matricula,
      escalaId: props.escalaId,
      atividadeTipoid: atividade_tipo.value.id,
      locomotiva: locomotiva.value,
      patioOrigemId: patioOrigem.value.id,
      patioDestinoId: patioDestino.value ? patioDestino.value.id : null,
      ordemDeServicoId: ordemDeServico.value ? ordemDeServico.value.id : null,
      observacao: observacao.value,
      adicionalZas: adicionalZas.value,
      adicionalSerraCremalheira: adicionalSerraCremalheira.value,
      adicionalMonoconducao: adicionalMonoconducao.value,
      adicionalMonitoria: adicionalMonitoria.value,
      matriculaMonitoria: matriculaMonitoria.value,
      marcacao: 1
    }
    try {
      active.value = true
      if (confirmacoes) {
        payload.value.confirmacoes = confirmacoes
      }

      if (props.id) {
        const resposta = await editarAtividade({
          id: atividadePorId.value.id,
          body: payload.value
        })

        emit('eventoAtividade')
        alertSucess(resposta.mensagemSucesso)
      } else {
        const resposta = await registrarAtividade(payload.value)
        alertSucess(resposta.mensagemSucesso)

        if (resposta.redirecionar) {
          push({
            name: 'gestao-periodo-voltar',
            params: {
              matricula: params.matricula,
              referencia: params.referencia
            }
          })
        } else {
          emit('eventoAtividade')
        }
      }

      dataAtividade.value = null
      atividade_tipo.value = null
      locomotiva.value = null
      patioOrigem.value = null
      patioDestino.value = null
      ordemDeServico.value = null
      observacao.value = null
      adicionalZas.value = false
      adicionalSerraCremalheira.value = false
      adicionalMonoconducao.value = false
      adicionalMonitoria.value = false
      adicionalMonitoria.value = false
      matriculaMonitoria.value = null
      atvDialog.value = false
      abrirAlerta.value = false
      active.value = false
      desabilitarConfirm.value = false

      await obterDetalhesAtividades(form.value)
    } catch (error) {
      active.value = false
      desabilitarConfirm.value = false
      if (error.response?.data) {
        const { mensagens, solicitarConfirmacao, codigo, confirmacoes } = error.response?.data

        if (solicitarConfirmacao) {
          confirmacoesLocal.value = []

          confirmacoes ? (confirmacoesLocal.value = confirmacoes) : (confirmacoesLocal.value = [])

          solicitarConfirmacaoLocal.value = solicitarConfirmacao
          codigoMensagem.value = codigo
          mensagemConfirmacao.value = mensagens[0]?.descricao

          abrirDialogAlerta()
        } else {
          if (mensagens[0]?.descricao) {
            alertWarn(mensagens[0]?.descricao)
          }
        }
      }
    }
    21
  }
}
</script>
<template>
  <div>
    <Button id="incluirAtividade" :icon="icon" :label="label" @click="abrirDialog()" class="p-button-incluir" :data-test="dataTest" />

    <Dialog v-model:visible="atvDialog" :style="{ width: '450px' }" :header="title" :modal="true" class="p-fluid" :closable="false" required>
      <label for="dataAtividade">
        <span v-if="data_fixa">Data Escala</span>

        <span v-if="data_fixa"> - {{ props.data_escala }}</span></label
      >
      <Skeleton v-if="loading" />
      <form class="form" v-else>
        <div class="field">
          <div class="flex">
            <div class="field">
              <label for="dataAtividade"> <span v-if="data_fixa">Data</span><span :class="{ invalid_label: !dataAtividade }">*</span> </label>
              <InputMask
                id="formDuracaoMaiorTempoData"
                class="inputtext p-inputtext-lg"
                v-if="data_fixa"
                v-model="dataAtividade"
                mask="99/99/9999"
                placeholder="Digite a data"
                :disabled="!permiteEditarHorario"
                @keyup="onKeypressData($event)"
                @blur="onChangeData($event)"
              />
            </div>
            <div class="field horaAtividade">
              <label for="dataAtividade">
                <span v-if="data_fixa">Hora</span>
                <span :class="{ invalid_label: !horaAtividade }"> *</span></label
              >
              <InputMask
                id="formDuracaoMaiorTempoHora"
                class="inputtext p-inputtext-lg"
                v-if="data_fixa"
                v-model="horaAtividade"
                mask="99:99"
                placeholder="Digite o horário"
                :disabled="!permiteEditarHorario"
                @blur="onChangeHora($event)"
              />
            </div>
          </div>
        </div>

        <div class="field">
          <label for="dataOrdemServico">O.S <span></span></label>

          <Dropdown
            :loading="loadingObter"
            id="ordemDeServico"
            class="w-full"
            :filter="true"
            v-model="ordemDeServico"
            :options="ordensDeServico"
            placeholder="Selecione a ordem de servico"
            optionLabel="dataInicio"
            @change="onChangeOrdemDeServico($event)"
            :disabled="!habilitarOs"
            showClear="true"
          />
        </div>

        <div class="field">
          <label for="dataAtividade">Tipo Atividade <span :class="{ invalid_label: !atividade_tipo }">*</span></label>

          <Dropdown
            :loading="loadingAtividadeTipo"
            id="atividadeTipo"
            class="w-full"
            :filter="true"
            v-model="atividade_tipo"
            :options="atividadeTipoAtivos"
            placeholder="Selecione o tipo da atividade"
            optionLabel="descricaoCompleto"
            @change="onChangeAtividadeTipo($event)"
          />
        </div>

        <div class="field">
          <label for="locomotiva">Prefixo</label>

          <InputMask
            v-if="!exibirPrefixo"
            id="locomotiva"
            v-model="locomotivaFake"
            mask="aaa9999"
            placeholder="Digite o Prefixo"
            maxlength="7"
            :autoClear="false"
            slotChar=""
            :disabled="!exibirPrefixo"
            style="text-transform: uppercase"
          />
          <InputMask
            v-if="exibirPrefixo"
            id="locomotiva"
            v-model="locomotiva"
            mask="aaa9999"
            placeholder="Digite o Prefixo"
            maxlength="7"
            :autoClear="false"
            slotChar=""
            style="text-transform: uppercase"
          />
        </div>
        <div class="field">
          <label for="patioOrigem">Pátio Origem <span :class="{ invalid_label: !patioOrigem }">*</span></label>

          <Dropdown
            :loading="loadingPatios"
            id="patioOrigem"
            class="w-full"
            :filter="true"
            v-model="patioOrigem"
            :options="patioFormato"
            placeholder="Selecione o pátio origem"
            optionLabel="descricaoCompleto"
            showClear="true"
          />
        </div>
        <div class="field">
          <label for="patioDestino">Pátio Destino</label>

          <Dropdown
            :loading="loadingObter"
            id="patioDestino"
            class="w-full"
            :filter="true"
            v-model="patioDestino"
            :options="patioFormato"
            placeholder="Selecione o pátio destino"
            optionLabel="descricaoCompleto"
            showClear="true"
            :disabled="!exibirDestino"
          />
        </div>
        <div class="field" v-if="configuracao.observacaoSolicitacaoObrigatorio">
          <label for="observacao">Observação</label>
          <Textarea v-model="observacao" rows="5" cols="30" />
        </div>

        <div class="field-checkbox">
          <Checkbox inputId="form.adicionalMonoconducao" :binary="true" v-model="adicionalMonoconducao" />
          <label for="form.adicionalMonoconducao">Adicional Monocondução</label>
        </div>

        <div class="field-checkbox">
          <Checkbox inputId="form.adicionalMonitoria" :binary="true" v-model="adicionalMonitoria" />
          <label for="form.adicionalMonitoria">Adicional Monitoria</label>
        </div>
        <div class="field">
          <InputMask
            id="matriculaMonitoria"
            v-model="matriculaMonitoria"
            mask="99999999"
            placeholder="Informe a matrícula do seu par na equipagem"
            maxlength="8"
            :autoClear="false"
            slotChar=""
          />
        </div>
        <div class="field-checkbox">
          <Checkbox inputId="form.AdicionalSerraCremalheira" :binary="true" v-model="adicionalSerraCremalheira" />
          <label for="form.AdicionalSerraCremalheira">Adicional Serra Cremalheira</label>
        </div>
        <div class="field-checkbox">
          <Checkbox inputId="form.adicionalZas" :binary="true" v-model="adicionalZas" />
          <label for="form.adicionalZas">Adicional Zas</label>
        </div>

        <div class="save">
          <Button label="Cancelar" icon="pi pi-times" class="p-button-text" @click="cancelar" />
          <Button :loading="active" id="btnSalvar" label="Salvar" icon="pi pi-save" class="p-button-text mr-2 ml-3" @click="salvarAtividade()" />
        </div>
      </form>
    </Dialog>
    <Dialog v-model:visible="abrirAlerta" :style="{ width: '350px' }" header="Atenção !" :modal="true" class="p-fluid" :closable="false" required>
      <span>{{ mensagemConfirmacao }}</span>
      <div class="flex align-items-center justify-content-around">
        <div class="m-1 w-full">
          <Button label="Não" icon="pi pi-times" class="p-button-danger btn-confirm" @click="abrirAlerta = false" />
        </div>

        <div class="m-1 w-full">
          <Button
            :class="{ btnDisabled: desabilitarConfirm }"
            label="Sim"
            icon="pi pi-check"
            class="p-button btn-confirm"
            :disabled="desabilitarConfirm"
            @click="confirmaAtividade()"
            :loading="active"
          />
        </div>
      </div>
    </Dialog>

    <Dialog
      v-model:visible="trocarOsDialog"
      :style="{ width: '350px' }"
      header="Confirmação!"
      :modal="true"
      class="p-fluid"
      :closable="false"
      required
    >
      <div class="flex">
        <span> Ao selecionar uma ordem de serviço, um ou todos os campos do registro podem ser alterados. Deseja prosseguir? </span>
      </div>
      <div class="w-full flex align-items-center justify-content-around">
        <div class="w-full flex p-2">
          <Button label="Não" icon="pi pi-times" class="p-button-danger btn-confirm" @click="cancelarPreenchhimentoOs()" />
        </div>
        <div class="w-full flex p-2">
          <Button label="Sim" icon="pi pi-check" class="p-button btn-confirm" @click="preencherAtividadeConformeOs()" />
        </div>
      </div>
    </Dialog>
  </div>
</template>
<style scoped lang="scss">
.save {
  display: flex;
}

.p-button-incluir {
  background-color: #cecece;
  border-radius: 20px;
  color: black;
  border: none !important;

  &:hover {
    background-color: #6666 !important;
    color: black !important;
  }
}

.invalid_label {
  color: red;
}

.btn-confirm {
  margin: 10px;
}

.horaAtividade {
  margin-left: 10px;
}

.btnDisabled {
  cursor: not-allowed !important;
}
</style>
